// @flow
import React, { Component } from 'react';
import {
  TextArea, Checkbox,
} from 'informed';

import { PrimaryText, SecondaryText } from '../../../Typography.jsx';
import ContentBox from '../../../ContentBox.jsx';

import styles from '../../../../styles/patientPages/progressNote/progressNote.scss';

type Props = {
  integumentary: Object,
}

class ViewIntegumentary extends Component<Props> {
  render() {
    const integumentary = this.props.integumentary || {};
    return (
      <ContentBox title='Integumentary'>
        <div className={styles.col}>
          <PrimaryText>Skin Assessment</PrimaryText><br />
          <div className={styles.section}>
            <SecondaryText>Color:</SecondaryText><br />
            <Checkbox disabled field='integumentary.parameters' initialValue={integumentary.parameters} />Within expected parameters for patient<br />
            <Checkbox disabled field='integumentary.rash' initialValue={integumentary.rash} />Rash<br />
            <Checkbox disabled field='integumentary.pale' initialValue={integumentary.pale} />Pale<br />
            <Checkbox disabled field='integumentary.flushed' initialValue={integumentary.flushed} />Flushed<br />
            <Checkbox disabled field='integumentary.cyanotic' initialValue={integumentary.cyanotic} />Cyanotic<br />
            <Checkbox disabled field='integumentary.jaundice' initialValue={integumentary.jaundice} />Jaundice<br />
            <Checkbox disabled field='integumentary.dusky' initialValue={integumentary.dusky} />Dusky<br />
            <Checkbox disabled field='integumentary.mottled' initialValue={integumentary.mottled} />Mottled<br />
            <Checkbox disabled field='integumentary.erythema' initialValue={integumentary.erythema} />Erythema<br />
            <Checkbox disabled field='integumentary.pigmentChange' initialValue={integumentary.pigmentChange} />Pigment change<br />
          </div>
          <div className={styles.section}>
            <SecondaryText>Temperature:</SecondaryText><br />
            <Checkbox disabled field='integumentary.warm' initialValue={integumentary.warm} />Warm<br />
            <Checkbox disabled field='integumentary.cool' initialValue={integumentary.cool} />Cool<br />
            <Checkbox disabled field='integumentary.coldExtremes' initialValue={integumentary.coldExtremes} />Cold extremities<br />
            <Checkbox disabled field='integumentary.coldCore' initialValue={integumentary.coldCore} />Cold core<br />
            <Checkbox disabled field='integumentary.hot' initialValue={integumentary.hot} />Hot
          </div>
          <div className={styles.section}>
            <SecondaryText>Skin turgor:</SecondaryText><br />
            <Checkbox disabled field='integumentary.goodElastic' initialValue={integumentary.goodElastic} />Good elasticity<br />
            <Checkbox disabled field='integumentary.poorElastic' initialValue={integumentary.poorElastic} />Poor elasticity<br />
            <Checkbox disabled field='integumentary.fragile' initialValue={integumentary.fragile} />Fragile<br />
            <Checkbox disabled field='integumentary.tenting' initialValue={integumentary.tenting} />Tenting<br />
            <Checkbox disabled field='integumentary.edema' initialValue={integumentary.edema} />Edema (see Cardiovascular Assessment)
          </div>
          <div className={styles.section}>
            <SecondaryText>Integrity:</SecondaryText><br />
            <Checkbox disabled field='integumentary.intact' initialValue={integumentary.intact} />Intact skin, no lesions<br />
            <Checkbox disabled field='integumentary.fragileInt' initialValue={integumentary.fragileInt} />Fragile integrity, tears easily<br />
            <Checkbox disabled field='integumentary.wound' initialValue={integumentary.wound} />Surgical wound<br />
            <Checkbox disabled field='integumentary.pressureUlcer' initialValue={integumentary.pressureUlcer} />Pressure ulcer
          </div>
          <div className={styles.section}>
            <SecondaryText>Moisture:</SecondaryText><br />
            <Checkbox disabled field='integumentary.moist' initialValue={integumentary.moist} />Moist<br />
            <Checkbox disabled field='integumentary.dry' initialValue={integumentary.dry} />Dry<br />
            <Checkbox disabled field='integumentary.diaphoretic' initialValue={integumentary.diaphoretic} />Diaphoretic<br />
            <Checkbox disabled field='integumentary.clammy' initialValue={integumentary.clammy} />Clammy
          </div>
          <div className={styles.section}>
            <SecondaryText>Skin Notes:</SecondaryText><br />
            <TextArea disabled field='integumentary.skinNotes' initialValue={integumentary.skinNotes} />
          </div>
          <PrimaryText>Hair Assessment</PrimaryText><br />
          <div className={styles.section}>
            <SecondaryText>Distribution:</SecondaryText><br />
            <Checkbox disabled field='integumentary.expectedDist' initialValue={integumentary.expectedDist} />Expected for sex<br />
            <Checkbox disabled field='integumentary.unexpectedDist' initialValue={integumentary.unexpectedDist} />Unexpected for sex
          </div>
          <div className={styles.section}>
            <SecondaryText>Characteristics:</SecondaryText><br />
            <Checkbox disabled field='integumentary.expectedChar' initialValue={integumentary.expectedChar} />Expected hair throughout<br />
            <Checkbox disabled field='integumentary.overabundance' initialValue={integumentary.overabundance} />Overabundance<br />
            <Checkbox disabled field='integumentary.alopeciaGen' initialValue={integumentary.alopeciaGen} />Alopecia, generalized<br />
            <Checkbox disabled field='integumentary.alopeciaSingle' initialValue={integumentary.alopeciaSingle} />Alopecia, single area<br />
            <Checkbox disabled field='integumentary.thinning' initialValue={integumentary.thinning} />Thinning
          </div>
          <div className={styles.section}>
            <SecondaryText>Health:</SecondaryText><br />
            <Checkbox disabled field='integumentary.dryHair' initialValue={integumentary.dryHair} />Dry, brittle<br />
            <Checkbox disabled field='integumentary.dyed' initialValue={integumentary.dyed} />Dyed<br />
            <Checkbox disabled field='integumentary.nits' initialValue={integumentary.nits} />Nits<br />
            <Checkbox disabled field='integumentary.healthyHair' initialValue={integumentary.healthyHair} />Healthy
          </div>
          <div className={styles.section}>
            <SecondaryText>Hair notes:</SecondaryText><br />
            <TextArea disabled field='integumentary.hairNotes' initialValue={integumentary.hairNotes} />
          </div>
          <PrimaryText>Nail Assessment</PrimaryText><br />
          <div className={styles.section}>
            <SecondaryText>Configuration:</SecondaryText><br />
            <Checkbox disabled field='integumentary.smooth' initialValue={integumentary.smooth} />Smooth and intact<br />
            <Checkbox disabled field='integumentary.pitting' initialValue={integumentary.pitting} />Pitting<br />
            <Checkbox disabled field='integumentary.pulling' initialValue={integumentary.pulling} />Pulling from nailbed
          </div>
          <div className={styles.section}>
            <SecondaryText>Color:</SecondaryText><br />
            <Checkbox disabled field='integumentary.pink' initialValue={integumentary.pink} />Pink<br />
            <Checkbox disabled field='integumentary.yellow' initialValue={integumentary.yellow} />Yellow discoloration<br />
            <Checkbox disabled field='integumentary.whiteSpots' initialValue={integumentary.whiteSpots} />White spots<br />
            <Checkbox disabled field='integumentary.pigmentedLines' initialValue={integumentary.pigmentedLines} />Pigmented lines
          </div>
          <div className={styles.section}>
            <SecondaryText>Condition:</SecondaryText><br />
            <Checkbox disabled field='integumentary.healthyNails' initialValue={integumentary.healthyNails} />Healthy appearance, well groomed<br />
            <Checkbox disabled field='integumentary.ingrown' initialValue={integumentary.ingrown} />Ingrown nail (describe in Notes)<br />
            <Checkbox disabled field='integumentary.nailTrauma' initialValue={integumentary.nailTrauma} />Nail trauma (describe in Notes)<br />
            <Checkbox disabled field='integumentary.otherNailCond' initialValue={integumentary.otherNailCond} />Other
          </div>
          <div className={styles.section}>
            <SecondaryText>Nail base:</SecondaryText><br />
            <Checkbox disabled field='integumentary.flatSmooth' initialValue={integumentary.flatSmooth} />Flat and smooth<br />
            <Checkbox disabled field='integumentary.ridged' initialValue={integumentary.ridged} />Ridged<br />
            <Checkbox disabled field='integumentary.spooning' initialValue={integumentary.spooning} />Spooning<br />
            <Checkbox disabled field='integumentary.clubbing' initialValue={integumentary.clubbing} />Clubbing (greater than 180 degrees)<br />
            <Checkbox disabled field='integumentary.transverseGroove' initialValue={integumentary.transverseGroove} />Transverse grooving<br />
            <Checkbox disabled field='integumentary.paronychia' initialValue={integumentary.paronychia} />PParonychia<br />
            <Checkbox disabled field='integumentary.splinter' initialValue={integumentary.splinter} />Splinter hemorrhages<br />
            <Checkbox disabled field='integumentary.infection' initialValue={integumentary.infection} />Infection<br />
            <Checkbox disabled field='integumentary.otherNailBase' initialValue={integumentary.otherNailBase} />Other
          </div>
          <div className={styles.section}>
            <SecondaryText>Nail notes:</SecondaryText><br />
            <TextArea disabled field='integumentary.nailNotes' initialValue={integumentary.nailNotes} />
          </div>
        </div>
      </ContentBox>
    );
  }
}

export default ViewIntegumentary;



// WEBPACK FOOTER //
// ./client/src/components/patientPages/progressNote/view/ViewIntegumentary.jsx